import json from './sprite.js';

export default {
    handle: 'en_SPT13-Game',
    label: 'en_SPT13-Game',
    json,
};
